import { Box, Button, Card, CardContent, Grid, Typography, Avatar, IconButton, Tooltip, Divider } from "@mui/material";
import React, { useState } from "react";
import CakeIcon from "../icons/CakeIcon";
import EmailIcon from "../icons/EmailIcon";
import CalendarIcon from "../icons/CalendarIcon";
import { PhoneIcon } from "../icons/PhoneIcon";
import MedalBronzeIcon from "../icons/MedalBronzeIcon";
import MedalSilverIcon from "../icons/MedalSilverIcon";
import MedalGoldenIncon from "../icons/MedalGoldenIncon";
import EditIcon from "@mui/icons-material/Edit";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import EditBirthdateModal from "./EditBirthdateModal";
import ModalProfileImage from "./ModalProfileImage";

const InfoItem = ({ icon, label, value, action }) => (
  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 3 }}>
    <Box sx={{
      p: 1.5,
      borderRadius: "12px",
      backgroundColor: "rgba(128, 31, 85, 0.05)",
      color: "#801F55",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}>
      {icon}
    </Box>
    <Box sx={{ flex: 1 }}>
      <Typography variant="caption" color="text.secondary" fontWeight="600" textTransform="uppercase" letterSpacing={1}>
        {label}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
        <Typography variant="body1" fontWeight="500" color="text.primary">
          {value}
        </Typography>
        {action}
      </Box>
    </Box>
  </Box>
);

const PersonalInformation = ({ usuario }) => {
  const miImagen = require("../../assets/img/default .png");
  //modal para editar la fecha de cumpleaños
  const [date, setDate] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const handleDateChange = (e) => {
    setDate(e.target.value);
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  //modal para la carga de imagen de perfil
  const [openImageModal, setOpenImageModal] = useState(false);
  const handleOpenImageModal = () => setOpenImageModal(true);
  const handleCloseImageModal = () => setOpenImageModal(false);

  return (
    <Card sx={{ borderRadius: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", overflow: "visible" }}>
      <CardContent sx={{ p: 4 }}>
        <Grid container spacing={4}>
          {/* Avatar Section */}
          <Grid item xs={12} sm={4} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Box sx={{ position: "relative" }}>
              <Avatar
                src={usuario?.profile_image || miImagen}
                alt={usuario?.name || "Imagen de perfil"}
                sx={{
                  width: 160,
                  height: 160,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                  border: "4px solid white",
                }}
              />
              <Tooltip title="Cambiar foto de perfil">
                <IconButton
                  onClick={handleOpenImageModal}
                  sx={{
                    position: "absolute",
                    bottom: 5,
                    right: 5,
                    backgroundColor: "#801F55",
                    color: "white",
                    "&:hover": { backgroundColor: "#601540" },
                  }}
                >
                  <PhotoCamera fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>

            <Typography variant="h5" fontWeight="bold" sx={{ mt: 3, textAlign: "center" }}>
              {usuario?.name?.toUpperCase() || "USUARIO"} {usuario?.first_lastname?.toUpperCase()}
            </Typography>

            {usuario?.profile_image === null && (
              <Typography variant="caption" color="success.main" sx={{ mt: 1, fontWeight: "bold" }}>
                ✨ Gana 1000 puntos al subir tu foto
              </Typography>
            )}
          </Grid>

          {/* Info Section */}
          <Grid item xs={12} sm={8}>
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: "#801F55" }}>
              Información Personal
            </Typography>
            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <InfoItem
                  icon={<EmailIcon width={24} height={24} />}
                  label="Correo electrónico"
                  value={usuario?.email || "No disponible"}
                />

                <InfoItem
                  icon={<PhoneIcon width={24} height={24} />}
                  label="Teléfono"
                  value={usuario?.phone || "No disponible"}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <InfoItem
                  icon={<CakeIcon width={24} height={24} />}
                  label="Cumpleaños"
                  value={usuario?.birthdate || "No disponible"}
                  action={
                    !usuario?.birthdate && (
                      <Tooltip title="Agregar fecha de cumpleaños">
                        <IconButton size="small" onClick={handleOpenModal} color="primary">
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )
                  }
                />
                {usuario?.birthdate === null && (
                  <Typography variant="caption" color="success.main" sx={{ display: "block", mt: -2, mb: 2, ml: 8, fontWeight: "bold" }}>
                    ✨ Gana 500 puntos
                  </Typography>
                )}

                <InfoItem
                  icon={<CalendarIcon width={24} height={24} />}
                  label="Miembro desde"
                  value={usuario?.member_since || "No disponible"}
                />
              </Grid>

              <Grid item xs={12}>
                <Box sx={{
                  mt: 2,
                  p: 2,
                  borderRadius: "16px",
                  background: "linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)",
                  display: "flex",
                  alignItems: "center",
                  gap: 2
                }}>
                  <Box>
                    {usuario.level === 3 ? (
                      <MedalBronzeIcon width={40} />
                    ) : usuario.level === 2 ? (
                      <MedalSilverIcon width={40} />
                    ) : (
                      usuario.level === 1 && <MedalGoldenIncon width={40} />
                    )}
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" fontWeight="bold" color="text.secondary">
                      NIVEL ACTUAL
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" sx={{
                      color: usuario.level === 3 ? "#cd7f32" : usuario.level === 2 ? "#757575" : "#DAA520"
                    }}>
                      {usuario.level === 3 ? "BRONCE" : usuario.level === 2 ? "PLATA" : usuario.level === 1 ? "ORO" : "ESTÁNDAR"}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Ganas el <b>{usuario.points_percentage}%</b> en puntos por cada compra
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Modals */}
        <EditBirthdateModal
          open={openModal}
          onClose={handleCloseModal}
          id={usuario?.id}
          onSave={(newDate) => {
            setOpenModal(false);
          }}
        />
        <ModalProfileImage
          open={openImageModal}
          handleClose={handleCloseImageModal}
          id={usuario?.id}
        />
      </CardContent>
    </Card>
  );
};

export default PersonalInformation;
